export const breakpoints = {
//   desktop: 1200,
  tablet: 768,
  phone: 480,
};

// helper for media queries
export const mq = Object.fromEntries(
  Object.entries(breakpoints).map(([label, size]) => [
    label,
    `@media (max-width: ${size}px)`,
  ])
);
